var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "th",
      {
        staticClass:
          "kpi-performance-table__metrics kpi-performance-table__endColGroup",
        attrs: { rowspan: "2" }
      },
      [_vm._v(_vm._s(_vm.title))]
    ),
    _vm._v(" "),
    _c(
      "th",
      {
        staticClass:
          "kpi-performance-table__endColGroup kpi-performance-table__big-header kpi-performance-table__halfHeader",
        attrs: { colspan: "5" }
      },
      [_vm._v("Current Month " + _vm._s(_vm.monthYearString))]
    ),
    _vm._v(" "),
    _c(
      "th",
      {
        staticClass:
          "kpi-performance-table__endColGroup kpi-performance-table__big-header kpi-performance-table__halfHeader",
        attrs: { colspan: "5" }
      },
      [_vm._v("Year to Date " + _vm._s(_vm.monthYearString))]
    ),
    _vm._v(" "),
    _c(
      "th",
      {
        staticClass: "kpi-performance-table__comments",
        attrs: { rowspan: "2" }
      },
      [_vm._v("Commentary")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }